import { create } from 'zustand'

type Position = { x: number; y: number }

interface TextSelectionMenuStore {
    anchor: HTMLElement | null
    text: string
    quote: string
    pos: Position
    actions: {
        openMenu: (anchor: HTMLElement, pos: Position, text: string) => void
        closeMenu: () => void
        copyText: () => void
        quoteText: () => void
        quoteClear: () => void
        addQuoteInRequestText: (requestText: string) => string
    }
}

export const useTextSelectionMenuStore = create<TextSelectionMenuStore>()((set, get) => ({
    anchor: null,
    text: '',
    quote: '',
    pos: { x: 0, y: 0 },
    actions: {
        openMenu: (anchor, pos, text) => {
            if (!text.trim()) return

            set({ anchor, pos, text: text.trim() })
        },
        closeMenu: () => set({ anchor: null, pos: { x: 0, y: 0 }, text: '' }),
        copyText: () => {
            const text = get().text

            navigator.clipboard.writeText(text)
            get().actions.closeMenu()
        },
        quoteText: () => {
            const text = get().text

            set({ quote: text })
            get().actions.closeMenu()
        },
        quoteClear: () => set({ quote: '' }),
        addQuoteInRequestText: (requestText) => {
            const quote = get().quote

            return quote
                ? `> \`\`\`\n> ${quote.replaceAll(`\n`, `\n> `)}\n\n${requestText}`
                : requestText
        },
    },
}))

export const useTextSelectionMenuActions = () => useTextSelectionMenuStore((state) => state.actions)
